import { alpha, createTheme} from '@mui/material/styles';
import { palette } from '@mui/system';

declare module '@mui/material/styles' {
  interface TypographyVariantsOptions {
    "tl-b"?: React.CSSProperties;
    "tl-m"?: React.CSSProperties;
    "tl-r"?: React.CSSProperties;
    "tm-b"?: React.CSSProperties;
    "tm-m"?: React.CSSProperties;
    "tm-r"?: React.CSSProperties;
    "ts-b"?: React.CSSProperties;
    "ts-m"?: React.CSSProperties;
    "ts-r"?: React.CSSProperties;
  }

  interface Palette {
    blue: {
        "600": string,
        "500": string,
        "100": string,
    },
    alpha: {
      'blue80': string,
      'blue12': string,
      'grey': string,
    }
    black: string,
    white: string,
  }

  interface PaletteOptions {
    blue: {
      "600": string,
      "500": string,
      "100": string,
    },
    alpha: {
      'blue80': string,
      'blue12': string,
      'grey': string,
    }
    black: string,
    white: string,
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    "tl-b"?:true
    "tl-m"?:true
    "tl-r"?:true
    "tm-b"?:true
    "tm-m"?:true
    "tm-r"?:true
    "ts-b"?:true
    "ts-m"?:true
    "ts-r"?:true
  }
}

const theme = createTheme({
  spacing: 10,
  breakpoints: {
    values: {
      xs: 0,
      sm: 500,
      md: 900,
      lg: 1024,
      xl: 1920,
    }
  },
  palette: {
    blue: {
      "600": '#2E5970',
      "500": '#34657F',
      "100": '#EDF5FA',
    },
    black: "#101010",
    white: '#FFF',
    alpha: {
      'blue80': alpha('#34657F', 0.8),
      'blue12': alpha('#34657F', 0.12),
      'grey': alpha('#666', 0.24)
    },
    grey: {
      900: "#444",
      800: "#666",
      700: "#AAA",
      500: "#CCC",
      400: "#D8D8D8",
      300: "#E5E5E5",
      200: "#F5F5F5",
      100: "#F9F9F9"
    },
  },
  typography: {
    "tl-b": {
      fontFamily: 'Pretendard',
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '28px',
    },
    "tl-m": {
      fontFamily: 'Pretendard',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '28px',
    },
    "tl-r": {
      fontFamily: 'Pretendard',
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '28px',
    },
    "tm-b": {
      fontFamily: 'Pretendard',
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
    },
    "tm-m": {
      fontFamily: 'Pretendard',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
    },
    "tm-r": {
      fontFamily: 'Pretendard',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
    },
    "ts-b": {
      fontFamily: 'Pretendard',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '20px',
    },
    "ts-r": {
      fontFamily: 'Pretendard',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          padding: 0,
          margin: 0,
          backgroundColor: 'white'
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Pretendard',
          fontSize: '18px',
          height: '44px',
          fontcolor: '#D8D8D8',
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '0.75rem',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiAutocomplete-popupIndicator': {
            padding: '0px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          fontFamily:
          '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
        },
      },
      variants: [
        {
          props: { variant: 'contained'},
          style: {
            background: '#AAA',
            color: 'white',
            '&:hover': {
              color: 'primary.main',
            },
          },
        },
        {
          props: { variant: 'outlined'},
          style: {
            borderColor: '#DBDBDB',
            color: '#666666',
          },
        },
      ],
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          margin: 0,
          padding: 0,
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          padding: 0,
          margin: 0,
          sm: 240,
          lg: 100,
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {}
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          width: '100%',
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        rail: {
          opacity: 1,
          height: 4,

        },
        track: {
          color: '#34657F',
          height: 4,
        },
        thumb: {
          color: "#34657F",
          width: 16,
          height: 16,
        },
      }
    }
  },
});

export default theme;
